import { useEffect, useState } from "react";
import "../../../../js/utils/webSocket";
import {
  addMessageListener,
  addPresenceListener,
  initWebSocket,
  subscribeChannels,
} from "../utils/webSocket";
import { useLiveSessionWSChat } from "./useLiveSessionWSChat";
import { useLiveSessionWSStateChange } from "./useLiveSessionWSStateChange";

export const useLiveSessionWS = ({
  chatMessages$,
  jwt,
  user,
  userRole,
  teacher,
  webSocketConfig,
} = {}) => {
  const [isWebSocketConnected, setWebSocketConnected] = useState(false);

  const { chatWSConfig, sendMessage } = useLiveSessionWSChat({
    chatMessages$,
    jwt,
    user,
    currentUserId: user?.id,
    teacherId: teacher?.id,
    isWebSocketConnected,
    webSocketConfig,
  });

  const {
    isSessionStreamingWSEvent,
    isSessionFinishedWSEvent,
    isSessionCancelledWSEvent,
    stateChangeOccupancy,
    stateChangeWSConfig,
  } = useLiveSessionWSStateChange({
    userRole,
    isWebSocketConnected,
    webSocketConfig,
  });

  const connectLiveSessionWS = async () => {
    const wsConnectionResult = await initWebSocket({
      uuid: user.id,
      authKey: webSocketConfig.authKey,
      publishKey: webSocketConfig.publishKey,
      subscribeKey: webSocketConfig.subscribeKey,
    });

    if (wsConnectionResult) {
      setWebSocketConnected(true);
    }
  };

  useEffect(() => {
    if (
      user?.id &&
      webSocketConfig?.authKey &&
      webSocketConfig.publishKey &&
      webSocketConfig.subscribeKey &&
      !isWebSocketConnected
    ) {
      connectLiveSessionWS();
    }
  }, [user, webSocketConfig]);

  useEffect(() => {
    if (chatWSConfig && stateChangeWSConfig) {
      addMessageListener({
        messagesListener: {
          ...chatWSConfig.messagesListener,
          ...stateChangeWSConfig.messagesListener,
        },
      });

      addPresenceListener({
        presenceListener: {
          ...stateChangeWSConfig.presenceListener,
        },
      });

      subscribeChannels({ channels: [...chatWSConfig.channels, ...stateChangeWSConfig.channels] });
    }
  }, [chatWSConfig, stateChangeWSConfig]);

  return {
    isSessionStreamingWSEvent,
    isSessionFinishedWSEvent,
    isSessionCancelledWSEvent,
    isWebSocketConnected,
    stateChangeOccupancy,
    sendMessage,
  };
};
